import Entity from '../entity'

export default class AgreementDocument extends Entity<number>{
    agreement_id: number;
    name: string;
    filename: string;

    fileData: string;
    filetype: string;
}


